import React from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import { Tooltip } from "react-tooltip"
import { useLocation } from "@gatsbyjs/reach-router"
import { getRoute } from "../helpers/routing"
import DownloadArea from "./DownloadArea"
import FilesAndSizeDisplay from "./timeline/FilesAndSizeDisplay"
import FilesSize from "./timeline/styled/FilesSize"
import TransferContainer from "./timeline/styled/TransferContainer"
import TransferManageUpload from "./timeline/styled/TransferManageUpload"
import UploadContent from "./timeline/styled/UploadContent"
import { TxlLink } from "./TxlLink"
import DownloadButton from "./DownloadButton"

const WrapIcon = styled.i`
  width: 30px;
  height: 30px;
  margin-left: -15px;
  left: 70px;
  position: absolute;
  font-size: 30px;
  color: ${props => props.theme.color.area};
  background-color: ${props => props.theme.color.encryption};
  border-radius: 50%;
  top: 25px;

  i {
    position: absolute;
    top: 7px;
    font-size: 15px;
    left: 50%;
    transform: translateX(-50%);
  }
`

const From = styled.strong`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  width: 130px;
  margin-left: 5px;
  top: 70px;
  margin-top: -10px;
`

const DownloadTransferContent = ({ transfer }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  const { pathname } = useLocation()

  const shortUrl = transfer.id
  const isEncrypted = transfer.status.isEncrypted
  const fromEmail = transfer.options.fromEmail
  const files = {
    fileCount: transfer.getTotalFileCount(),
    fileSize: transfer.getTotalFileSize(),
  }

  return (
    <DownloadArea>
      <TransferContainer>
        {isEncrypted && (
          <WrapIcon
            data-tooltip-id="downloadarea_tooltip"
            data-tooltip-content={t("##.Transfers.Encrypted")}
          >
            <i className="icon-lock" />
          </WrapIcon>
        )}
        <From
          data-tooltip-id="downloadarea_tooltip"
          data-tooltip-content={fromEmail}
        >
          {fromEmail}
        </From>
        <TransferManageUpload>
          <TxlLink to={getRoute(`/details/${shortUrl}`, language)} state={{ from: pathname }}>
            <UploadContent>
              <FilesSize as={FilesAndSizeDisplay} {...files} />
              <i className="icon-arrow-right-small" />
            </UploadContent>
          </TxlLink>
        </TransferManageUpload>
      </TransferContainer>
      <DownloadButton transfer={transfer} />
      <Tooltip id="downloadarea_tooltip" />
    </DownloadArea>
  )
}

export default DownloadTransferContent
